var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIconPlaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6663 35.6511C34.6663 37.1231 33.4717 38.3177 31.9997 38.3177C30.5277 38.3177 29.333 37.1231 29.333 35.6511V22.3177C29.333 20.8457 30.5277 19.6511 31.9997 19.6511C33.4717 19.6511 34.6663 20.8457 34.6663 22.3177V35.6511ZM31.9997 46.3177C30.5277 46.3177 29.333 45.1231 29.333 43.6511C29.333 42.1791 30.5277 40.9844 31.9997 40.9844C33.4717 40.9844 34.6663 42.1791 34.6663 43.6511C34.6663 45.1231 33.4717 46.3177 31.9997 46.3177ZM31.9997 6.31775C17.2717 6.31775 5.33301 18.2564 5.33301 32.9844C5.33301 47.7124 17.2717 59.6511 31.9997 59.6511C46.7277 59.6511 58.6663 47.7124 58.6663 32.9844C58.6663 18.2564 46.7277 6.31775 31.9997 6.31775Z",
    fill: "#F5821F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconPlaid);
export default __webpack_public_path__ + "static/media/pendingIconPlaid.683601ded7532f2adb217c4bbf0c88dc.svg";
export { ForwardRef as ReactComponent };